export default {
    "dynamicFormsRename_title": "Rename form: ",
    "dynamicFormsRename_success": "Success",
    "dynamicFormsRename_successMessage": "Form renamed"
}